import { render, staticRenderFns } from "./productPro.vue?vue&type=template&id=5e507a88&scoped=true"
import script from "./productPro.vue?vue&type=script&lang=js"
export * from "./productPro.vue?vue&type=script&lang=js"
import style0 from "./productPro.vue?vue&type=style&index=0&id=5e507a88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e507a88",
  null
  
)

export default component.exports